// Function to get time-based greeting key (returns full i18n key)
export const getTimeBasedGreetingKey = () => {
  const hour = new Date().getHours()

  if (hour >= 5 && hour < 12) {
    return 'common:greetings.good_morning_with_name' as const
  } else if (hour >= 12 && hour < 17) {
    return 'common:greetings.good_afternoon_with_name' as const
  } else if (hour >= 17 && hour < 22) {
    return 'common:greetings.good_evening_with_name' as const
  } else {
    return 'common:greetings.good_night_with_name' as const
  }
}
